









































import { Component, Vue } from 'vue-property-decorator';
import { MSG_BIP, MSG_SMS, trMsg } from "./bip-types";
import DatePicker from "vue2-datepicker";

@Component({
    name: 'modal-date',
    components: {
        DatePicker   // ← регистрация компонента здесь
    }
})
export default class modalDate extends Vue {
    private MSG_SMS = MSG_SMS;
    private MSG_BIP = MSG_BIP;

    private showModal = false;
    private budget_date = new Date();

    private showEvent() {
        this.showModal = true;
        this.budget_date = new Date();
    }

    private emitDate() {
        this.$emit('emitDate', this.budget_date);
        this.showModal = false;
    }

    // translate messages
    private trMsg(field: string) {
        return trMsg(this, field);
    }
}
